module Meevo.Plugins.GiftCardBalance {
    class GiftCardBalanceModalController {

        protected isThirdPartyGc: boolean = false;
        protected thirdPartyBalance: number = 0;
        protected isLookupFailure: boolean = false;
        isRestricted: boolean = false;
        protected isLookupSuccess: boolean = false;
        protected errorDetail: string;
        protected gcHistory: any;
        protected expandedDetails: any = undefined;
        protected hasGiftCardBalance: boolean = false;
        protected allowGiftCardReload: boolean = false;

        protected selectedGcId: string;
        protected selectedClientId: string;
        protected giftCardItems: any[];

        protected meevoSecurityKeys = Meevo.Components.Common.SecurityKeys;

        private minStartDate: Date;
        private currentItemIndex: number;
        private changeValidFromDate: Model.SecurityAccessEnum;
        private get isEditing(): boolean {
            return _(this.giftCardItems).any(item => item.isEditing);
        }

        static $inject = [
            "giftCardNumber",
            "giftCardId",
            "meevo.AppSettings",
            "meevo.components.common.DataService",
            "meevo.components.busy.BusyService",
            "meevo.components.tracking.TrackingService",
            "meevo.components.modal.ModalService",
            "$mdDialog",
            "$timeout",
            "$rootScope",
            "$translate",
            "$q",
            "meevo.plugins.register.RegisterGiftCardService",
            "meevo.components.common.SecurityService"
        ];

        constructor(protected giftCardNumber: string,
            protected giftCardId: string,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected modalService: Meevo.Components.Modal.ModalService,
            protected $mdDialog: ng.material.IDialogService,
            protected $timeout: ng.ITimeoutService,
            protected $rootScope: ng.IRootScopeService,
            protected $translate: angular.translate.ITranslateService,
            protected $q: angular.IQService,
            public registerGiftCardService: Meevo.Plugins.Register.RegisterGiftCardService,
            protected securityService: Meevo.Components.Common.ISecurityService
        ) {
            this.$timeout(() => this.setFocusOnField(), 1000);

            this.getRegisterSettings().then(() => {
                if (!_.isEmpty(this.giftCardNumber) || !_.isEmpty(this.giftCardId)) {
                    this.search();
                }
            });

            this.securityService.checkSecurityKey(this.meevoSecurityKeys.REGISTER_REGISTER_GIFTCARDS_CHANGEVALIDFROMDATES + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then(result => {
                this.changeValidFromDate = result;
            });

            this.minStartDate = moment().startOf('day').toDate();
        }

        setFocusOnField() {
            $("#gcNumber input").focus();
        }

        showLog(giftCard) {
            if (giftCard.logItems) {
                return;
            }
            this.dataService.customMethodData(`/api/ClientGiftCard/${giftCard.gcId}/History`, "get", {}).then(response => {
                giftCard.logItems = response.data;
            });
        }

        showGiftCardNumber(giftCard) {
            this.dataService.customMethodData(`/api/ClientGiftCard/${giftCard.gcId}/Unmasked`, "get", {}).then(response => {
                giftCard.giftCardNumber = response.data.giftCardNumberUnmasked;
                giftCard.isMasked = false;
            });
        }

        search(): void {
            if (!_.isEmpty(this.giftCardNumber) || !_.isEmpty(this.giftCardId)){
                let item = new Model.TrackingItem(Model.NounEnum.GiftCardBalance, Model.VerbEnum.SearchButtonClicked, { giftCardNumber: this.giftCardNumber }, null);
                this.trackingService.saveTrackingInfo(item);

                this.isLookupSuccess = false;
                this.isLookupFailure = false;
                this.isRestricted = false;
                this.errorDetail = "";
                this.gcHistory = [];
                this.expandedDetails = undefined;

                this.busyService.start();

                let meevoGiftCardSearch = () => {
                    // Check for Meevo-sold GC
                    var gcRequest = {
                        criteria: {
                            giftCardNumber: this.giftCardNumber,
                            giftCardId: this.giftCardId,
                            nonZeroBalanceOnly: null,
                            activeOnly: null,
                        }
                    };

                    this.dataService.getListPaged("ClientGiftCard", gcRequest).then((data: any) => {
                        if (data && data.length > 0) {
                            data = _(data).reject((card: any) => !this.registerGiftCardService.checkGCUsageRestriction(card));
                            if (data.length === 0) {
                                this.isRestricted = true;
                            }
                        }
                        if (data && data.length > 0) {
                            this.giftCardItems = [];

                            data.forEach(giftCardItem => {
                                const item = {
                                    gcId: giftCardItem.id,
                                    clientId: giftCardItem.clientId,
                                    startDate: giftCardItem.startDate,
                                    purchasedBy: giftCardItem.purchaserDisplayName,
                                    purchasedFor: giftCardItem.clientDisplayName,
                                    originalBalance: giftCardItem.originalAmount,
                                    remainingBalance: giftCardItem.remainingAmount,
                                    hasGiftCardBalance: Model.Guard.isSomething(giftCardItem.originalAmount) && Model.Guard.isSomething(giftCardItem.remainingAmount),
                                    expirationDate: giftCardItem.expireDate,
                                    selectedClientId: giftCardItem.clientId,
                                    giftCardNumber: giftCardItem.giftCardNumber,
                                    isMasked: true,
                                    giftCardTypeId: giftCardItem.giftCardTypeId,
                                    giftCardTypeDisplayName: giftCardItem.giftCardTypeDisplayName,
                                    gcHistory: [],
                                    isThirdPartyGc: true,
                                    isLookupSuccess: false,
                                    isLookupFailure: true,
                                    entityVersion: giftCardItem.entityVersion,
                                    note: giftCardItem.note,
                                    originalNote: giftCardItem.note,
                                    isExpired: giftCardItem.isExpired,
                                    isActive: giftCardItem.isActive,
                                    isArchived: giftCardItem.isArchived,
                                    originalStartDate: giftCardItem.startDate,
                                    originalPurchasedFor: giftCardItem.clientDisplayName,
                                    originalClientId: giftCardItem.clientId,
                                    isGiftCardUsed: giftCardItem.isGiftCardUsed,
                                    saleLocationId: giftCardItem.saleLocationId,
                                    client: {
                                        id: giftCardItem.clientId,
                                        displayName: this.$translate.instant(giftCardItem.clientDisplayName),
                                        clientType: giftCardItem.clientId ?
                                            Model.ClientTypeEnum.Client :
                                            Model.ClientTypeEnum.AnonymousOther
                                    }
                                };

                                this.giftCardItems.push(item);

                                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Client/${emptyGuid()}/GiftCard/${item.gcId}?includePromoOffset=true`,
                                    'GET', null).then((response: any) => {

                                        if (response.data && response.data.length > 0) {

                                            _.forEach(response.data, (item: any) => {
                                                item['displayDate'] = moment(item.transactionDateTime).format("L LTS");
                                            });

                                            item.isThirdPartyGc = false;
                                            item.isLookupSuccess = true;
                                            item.isLookupFailure = false;

                                            _.forEach(response.data, (item: any) => {
                                                item['displayDate'] = moment(item.transactionDateTime).format("L LTS");
                                            });
                                            item.gcHistory = response.data;

                                            this.isThirdPartyGc = false;
                                            this.isLookupSuccess = true;
                                            this.isLookupFailure = false;
                                        } else {
                                            this.isLookupSuccess = false;
                                            this.isLookupFailure = true;
                                        }

                                        this.busyService.stop();
                                    });
                            });

                        } else {
                            this.isLookupFailure = true;
                            this.isLookupSuccess = false;

                            this.busyService.stop();
                        }
                    });
                }

                if (!_.isEmpty(this.giftCardId)) {
                    meevoGiftCardSearch();
                    this.giftCardId = null;
                    return;
                }

                var request = {
                    prefix: this.giftCardNumber
                };

                // First check for 3rd party GC
                this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Tenant/GiftCardExternalBin/CheckBin`,
                    'POST',
                    request).then((response: any) => {
                        if (!_.isEmpty(response.data.prefix)) {
                            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/GiftCardExternalBin/CheckBalance`,
                                'POST',
                                { giftCardNumber: this.giftCardNumber }).then((response: any) => {
                                    this.busyService.stop();
                                    if (response.data.processingStatus === Meevo.Model.ProcessingStatusEnum.Success) {
                                        this.isThirdPartyGc = true;
                                        this.thirdPartyBalance = response.data.balanceAmount;
                                        this.isLookupSuccess = true;
                                        this.isLookupFailure = false;
                                    } else {
                                        this.isLookupFailure = true;
                                        this.isLookupSuccess = false;
                                        var detail = JSON.parse(response.data.processorResponseDetail);
                                        this.errorDetail = detail.expressResponseMessage;
                                    }
                                });
                        } else {
                            meevoGiftCardSearch();
                        }
                    });
            }
        }

        saveCurrentItem() {
            const item = _(this.giftCardItems).find(item => item.isEditing);
            if (!item) {
                return;
            }

            this.save(item);
        }

        save(item) {
            const currentLocationId = this.appSettings.APP_BUSINFOSETTINGS.locationId;
            if (currentLocationId && item.saleLocationId && currentLocationId != item.saleLocationId) {
                this.modalService.alert("MESSAGE_GIFT_CARD_UNABLE_TO_EDIT_FROM_ANOTHER_LOCATION", Meevo.Components.Modal.ModalTranslationModes.Translate, true);
                return;
            }

            if (!item.startDate || (!item.clientId && !item.client) || 
                (item.startDate !== item.originalStartDate && item.startDate < this.minStartDate) ||
                (item.startDate > item.expirationDate)) {
                return;
            }

            const showGiftCardError = () => {
                return this.modalService.error(this.$translate.instant("MESSAGE_ERROR_GIFTCARD"), Meevo.Components.Modal.ModalTranslationModes.Translate, true);
            }

            item.id = item.gcId;
            const request = {
                Model: {
                    startDate: item.startDate,
                    note: item.note
                },
                EntityVersion: item.entityVersion
            }

            this.busyService.start();
            return this.dataService.customMethodData(`${this.appSettings.API_ROOT}/ClientGiftCard/${item.id}`, 'PATCH', request)
                .then((response: any) => {
                    const giftCard = response.data;

                    if (giftCard && giftCard.updatedSuccessfully) {
                        item.note = giftCard.note;
                        item.originalNote = giftCard.note;
                        item.entityVersion = giftCard.entityVersion;
                        item.startDate = giftCard.startDate;
                        item.originalStartDate = giftCard.startDate;
                        return;
                    }
                        
                    item.note = item.originalNote;
                    item.startDate = item.originalStartDate;                        

                    this.busyService.stop();
                    return showGiftCardError();
                })
                .catch(() => {
                    item.note = item.originalNote;
                    item.startDate = item.originalStartDate;
                })
                .finally(() => {
                    item.isEditing = false;
                    this.busyService.stop();
                });
        }


        editGiftCard(item, $index) {
            item.isEditing = true;
            this.currentItemIndex = $index;
        }

        cancelCurrentItem() {
            const item = _(this.giftCardItems).find(item => item.isEditing);
            if (!item) {
                return;
            }

            this.cancel(item);
        }

        cancel(item) {
            item.note = item.originalNote; 
            item.startDate = item.originalStartDate;
            item.purchasedFor = item.originalPurchasedFor;
            item.clientId = item.originalClientId;
            item.isEditing = false;
        }

        closeModal() {
            if (this.isEditing) {
                this.modalService.alert('MESSAGE_PENDING_CHANGES', Meevo.Components.Modal.ModalTranslationModes.Translate, true);
                return;
            }

            this.$mdDialog.cancel();
        }

        private getRegisterSettings(): ng.IPromise<any> {
            return this.dataService.customMethodData("api/tenant/businessInfo/settings", "get", null).then((response) => {
                this.allowGiftCardReload = response.data.registerSettings.reloadGiftCard;
            });
        }

        openRegister(item) {
            if (!item || !item.giftCardNumber || !item.isLookupSuccess) {
                return;
            }

            if (item.remainingBalance > 0 && !this.allowGiftCardReload) {
                this.modalService.alert("MESSAGE_GIFT_CARD_RELOAD_NOT_ALLOWED", Meevo.Components.Modal.ModalTranslationModes.Translate, true);
                return;
            }

            this.$mdDialog.hide().then(() => {
                this.launchRegister(item);
            });
        }

        private launchRegister(item) {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.register,
                stateParams: {
                    action: Meevo.Components.Common.Messages.REGISTER_RELOAD_CLIENT_GIFTCARD,
                    clientId: item.selectedClientId,
                    gcId: item.gcId,
                    gcNumber: item.giftCardNumber,
                    gcAmount: item.remainingBalance
                }
            });
        }

        viewGiftCardHistoryDetails(item) {
            item.expandedDetails = item.expandedDetails ? !item.expandedDetails : true;
        }

        openTransactionEditor(transactionNumber: string) {
            if (!transactionNumber) {
                return;
            }

            this.$mdDialog.hide().then(() => {
                this.launchTransEditor(transactionNumber);
            });
        }

        private launchTransEditor(transactionNumber: string) {
            this.$rootScope.$broadcast(Meevo.Components.Common.Messages.GOTO_STATE, {
                stateName: this.appSettings.ROUTE_NAMES.transactionEditor,
                stateParams:  {
                    transactionId: transactionNumber,
                    includeActive: true,
                    includeCompleted: true,
                    includeOnHold: false,
                    includeRefunded: true,
                    includeVoided: true
                },
                securityKey: Meevo.Components.Common.SecurityKeys.REGISTER_TRANSACTIONEDITOR + Meevo.Components.Common.SecurityParts.KEY_PART_READ,
            });
        }

        isGiftCardReloadVisible(item) {
            return item && !item.isThirdPartyGc && item.isActive && !item.isArchived && item.remainingBalance > 0;
        }

        useAnonymousClient(item) {
            const client = {
                id: undefined,
                clientType: Model.ClientTypeEnum.AnonymousOther,
                displayName: this.$translate.instant("LABEL_GIFTCARD_PURCHASED_FOR_ANONYMOUS")
            };

            item.client = client;
            item.clientId = undefined;
        }

        canEditStartDate(item) {
            return item.isEditing && !item.isGiftCardUsed && item.originalStartDate >= this.minStartDate && item.remainingBalance > 0;
        }

        canViewStartDate(item) {
            return item.originalStartDate < this.minStartDate || this.changeValidFromDate !== Model.SecurityAccessEnum.Hide;
        }

        get lookupFailureMessage() {
            if (this.isRestricted) {
                return "MESSAGE_MODAL_GIFT_CARD_RESTRICTED_ACROSS_LOCATIONS";
            }
            else if (this.hasGiftCardBalance) {
                return "MESSAGE_GC_DETAIL_UNAVAILABLE";
            }
            return "MESSAGE_ERROR_RETRIEVING_GC"
        }
    }

    angular.module("meevo.plugins.giftCardBalance")
        .controller("meevo.plugins.giftCardBalance.GiftCardBalanceModalController", GiftCardBalanceModalController);
}